// extracted by mini-css-extract-plugin
export var label = "Newsletter-module--label--PNSYD";
export var subtitle = "Newsletter-module--subtitle--eq4cI";
export var title = "Newsletter-module--title--2L9p0";
export var wrapper = "Newsletter-module--wrapper--VRjV6";